import { validate } from "isemail";
import { INVALID_EMAIL, INVALID_PHONE, INVALID_POSTCODE, INVALID_REFERENCE_NUMBER, INVALID_CONTACT_NUMBER } from "../constants/validation";
const UK_POSTCODE_REGEX = /^((GIR[ ]?0AA)|([a-zA-Z]{1,2}(([0-9]{1,2})|([0-9][a-zA-Z]))[ ]?[0-9][a-zA-Z]{2})){1}$/;
const PARCEL_REFERENCE_NUMBER_REGEXP = /^[\w*]{5,28}$/;
const COLLECTION_REFERENCE_NUMBER_REGEXP = /^\d{7}$|^\d{10}$|^\d{11}$/;
const PHONE_NUMBER_REGEXP = /^(\+44|0044)?0?7[0-9]{9}$/;
const CONTACT_NUMBER_REGEXP = /^(\d|\s){7,15}$|^[\+](\d|\s){7,14}$/;
export const required = (message = "This field is required") => value => value ? null : message;

const isParcelReferenceNumberValid = refNumber => {
  const val = refNumber.replace(/ /g, "");
  return !val || PARCEL_REFERENCE_NUMBER_REGEXP.test(val);
};

const isCollectionReferenceNumberValid = refNumber => {
  const val = refNumber.replace(/ /g, "");
  return !val || COLLECTION_REFERENCE_NUMBER_REGEXP.test(val);
};

export const validateParcelReferenceNumberWithMessage = (refNumber = "") => isParcelReferenceNumberValid(refNumber) ? null : INVALID_REFERENCE_NUMBER;
export const validateCollectionReferenceNumberWithMessage = (refNumber = "") => isCollectionReferenceNumberValid(refNumber) ? null : INVALID_REFERENCE_NUMBER; // we don't want to check if value is exist here, it's only for format validation, so `!val` is present

const isPostcodeValid = postcode => !postcode || UK_POSTCODE_REGEX.test(postcode);

export const validatePostcodeWithMessage = (postcode = "") => isPostcodeValid(postcode) ? null : INVALID_POSTCODE;
export const isPhoneValid = value => !value || PHONE_NUMBER_REGEXP.test(value);
export const isEmailValid = value => !value || validate(value);
export const isContactNumberValid = value => !value || CONTACT_NUMBER_REGEXP.test(value);
export const validatePhoneWithMessage = (phone = "") => isPhoneValid(phone) ? null : INVALID_PHONE;
export const validateEmailWithMessage = (email = "") => isEmailValid(email) ? null : INVALID_EMAIL;
export const validateContactNumberWithMessage = (contactNumber = "") => isContactNumberValid(contactNumber) ? null : INVALID_CONTACT_NUMBER;
export const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;
export const maxLength16 = maxLength(16);